import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Exchange({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <Exchange.Outline {...props} />
  ) : (
    <Exchange.Solid {...props} />
  );
}

Exchange.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M20.791 7.32031C20.791 7.38485 20.7829 7.44749 20.7675 7.50724C20.7344 7.63671 20.6672 7.75612 20.5709 7.85201L16.4742 11.9298C16.1806 12.222 15.7057 12.2209 15.4135 11.9273C15.1213 11.6338 15.1224 11.1589 15.416 10.8667L18.2253 8.07031L6.42324 8.07031C6.00902 8.07031 5.67324 7.73453 5.67324 7.32031C5.67324 6.9061 6.00902 6.57031 6.42324 6.57031L18.225 6.57031L15.416 3.77423C15.1224 3.48201 15.1213 3.00714 15.4135 2.71357C15.7057 2.42 16.1806 2.41891 16.4742 2.71112L20.5709 6.7889C20.662 6.87964 20.7271 6.99132 20.7619 7.11268C20.7809 7.17862 20.791 7.24828 20.791 7.32031Z"
          fill="currentColor"
        />
        <path
          d="M17.3276 17.9988C17.7418 17.9988 18.0776 17.663 18.0776 17.2488C18.0776 16.8346 17.7418 16.4988 17.3276 16.4988L5.52573 16.4988L8.33501 13.7025C8.62858 13.4102 8.62968 12.9354 8.33746 12.6418C8.04525 12.3482 7.57037 12.3471 7.2768 12.6393L3.18014 16.7171C3.09229 16.8046 3.02858 16.9115 2.99292 17.0279C2.97505 17.086 2.96403 17.147 2.96083 17.2102C2.96019 17.223 2.95986 17.2358 2.95986 17.2488C2.95986 17.2508 2.95987 17.2528 2.95988 17.2549C2.95999 17.2691 2.9605 17.2832 2.96139 17.2972C2.9656 17.3632 2.97834 17.4269 2.99853 17.4872C3.03508 17.5966 3.09673 17.6972 3.18014 17.7802L7.2768 21.858C7.57037 22.1502 8.04525 22.1491 8.33746 21.8556C8.62968 21.562 8.62858 21.0871 8.33501 20.7949L5.52594 17.9988L17.3276 17.9988Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Exchange.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M15.34 0.999817H6.67C3.28 0.999817 1 3.37982 1 6.91982V15.0898C1 18.6198 3.28 20.9998 6.67 20.9998H15.34C18.73 20.9998 21 18.6198 21 15.0898V6.91982C21 3.37982 18.73 0.999817 15.34 0.999817Z"
          className="icon-secondary"
        />
        <path
          d="M17.7935 7.12888H9"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
        <path
          d="M15.6548 5L17.7931 7.12881L15.6548 9.25835"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
        <path
          d="M3.99998 14.7021L12.7935 14.7021"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
        <path
          d="M6.13867 16.831L4.00037 14.7022L6.13867 12.5726"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
